// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./languages/en";
import translationES from "./languages/es";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      es: { translation: translationES },
    },
    supportedLngs: ["en", "es"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "en",
    detection: {
      order: [
        // Only an intentional menu selection overrides the device/browser.
        "localStorage",
        "navigator",
        "htmlTag",
      ],
      lookupLocalStorage: "pointgenieLanguagePreference",
      caches: [],
    },
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  });

export default i18n;
